<div class="flex flex-wrap">
  <app-license-overview-card
    class="w-full max-w-[600px] py-2 xl:w-1/2 xl:pr-2"
    (addLicensesButtonClickEvent)="onAddLicensesButtonClick()"
  />
  @if (isHRISEnabled()) {
    <app-hris-integration-card
      class="w-full max-w-[600px] py-2 xl:w-1/2 xl:pl-2"
    />
  }
</div>
@if (isLoading()) {
  <div class="mt-8 flex min-h-[200px] items-center justify-center">
    <div class="size-[50px]">
      <app-loading />
    </div>
  </div>
} @else if (users(); as users) {
  <div class="mt-8" animate.enter="ease-in-fast">
    <app-user-table [users]="users"></app-user-table>
  </div>
}
